import saferEval from 'safer-eval'
import vueConfig from '../../../../../../vue.config.js'

const mixinExtMenu = {
  data() {
    return {
      dialogVisible: false,
      dialogItem: {},
      iframeWin: {},
      height: 100
    }
  },
  computed: {
    extMenu1() {
      const {
        extMenu
      } = this.column

      if (extMenu?.length) {
        return extMenu.filter(item => {
          const {
            viewPageShow,
            btnType
          } = item
          if (this.isViewPage) {
            return viewPageShow === true && item.btnType === 1
          } else {
            return btnType === 1
          }
        })
      }

      return []
    },
    extMenu2() {
      const {
        extMenu
      } = this.column
      let extMenu2 = [] // allowAdd
      if (extMenu?.length) {
        extMenu2.push(extMenu.filter(item => {
          const {
            viewPageShow,
            btnType
          } = item
          if (this.isViewPage) {
            return viewPageShow === true && item.btnType === 2
          } else {
            return btnType === 2
          }
        })
        )
      }
      if (this.column.templatePathFileListImport && this.column.templatePathFileListImport.length > 0 && this.column.allowAdd) {
        extMenu2.push(
          { 'name': '导入',
            'btnType': 2,
            'prop': 'import-excel',
            'buttonStyleType': 'success',
            'icon': 'fa fa-download' })
        extMenu2.push(
          { 'name': '下载模板',
            'btnType': 2,
            'prop': 'download-template',
            'buttonStyleType': 'success',
            'icon': 'fa fa-download' })
      }

      if (this.column.templatePathFileListExport && this.column.templatePathFileListExport.length > 0) {
        extMenu2.push(
          { 'name': '导出',
            'btnType': 2,
            'prop': 'download-data',
            'buttonStyleType': 'success',
            'icon': 'fa fa-download' })
      }

      return extMenu2
    }
  },
  watch: {
    dialogVisible(v) {
      if (v) {
        setTimeout(() => {
          this.iframeWin = this.$refs.iframe.contentWindow
        }, 1000)
      }
    },
    dialogItem(item) {
      const zoom = document.documentElement.style.zoom
      if (item.fullscreen) {
        const clientHeight = document.documentElement.clientHeight
        if (zoom) {
          this.height = clientHeight / zoom - 60
        } else {
          this.height = clientHeight
        }
      } else if (item.height) {
        if (item.height.indexOf('%')) {
          this.height = parseInt(this.dialogItem.height.replace('%', '')) * document.documentElement.clientHeight / 100
        } else {
          this.height = item.height
        }
      }
    }
  },
  mounted() {
    window.addEventListener('message', ({ data }) => {
      switch (data.type) {
        case 'close': {
          this.dialogVisible = false
          break
        }
        case 'replace': {
          const {
            prop
          } = this.column
          if (this.dialogVisible) {
            this.viewFormData.modelData[prop] = data.data
          }
          this.dialogVisible = false
          break
        }
      }
    })
  },
  methods: {
    uploading(event) {
      this.uploadView.form.file = event.target.files[0]// 获取文件
      var windowURL = window.URL || window.webkitURL
      this.uploadView.form.file = event.target.files[0]
      // 创建图片文件的url
      this.uploadView.form.src = windowURL.createObjectURL(event.target.files[0])
      this.uploadView.form.label = this.uploadView.form.file.name
      this.uploadView.label = this.uploadView.form.file.name
    },
    importExcelClose() {
      this.uploadView.label = '上传文件'
      this.uploadView.form.file = null
      this.$refs.referenceUpload.value = null
    },
    updateFile: function() {
      this.$refs.uploadView.validate((valid) => {
        // /excel-import/import-sub-form
        if (valid) {
          if (!this.uploadView.form.file) {
            return this.$message.error('请选择文件')
          }
          let formData = new window.FormData() // vue 中使用 window.FormData(),否则会报 'FormData isn't definded'
          formData.append('file', this.uploadView.form.file)
          this.$http.post('/excel-import/import-sub-form', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }, params: {
              subProp: this.column.prop,
              formId: this.viewFormData.options.formId
            }
          }).then((res) => {
            this.uploadView.show = false
            // res.data.forEach(item => {
            //   item.testSelect = '1'
            // })
            this.value.push(...res.data)
          }).catch((error) => {
            this.$message.error(error.msg)
          })
        }
      })
    },
    defaultValueSet() {
      let currentDynamic = this.viewFormData.options.column.filter(item => item.prop === this.column.prop)
      if (currentDynamic.length === 0 && this.viewFormData.options.group) {
        this.viewFormData.options.group.forEach(groupItem => {
          groupItem.column.filter(item => item.prop === this.column.prop).forEach(item => {
            currentDynamic.push(item)
          })
        })
      }
      const { column } = currentDynamic[0].children
      const vals = {}
      if (column.length) {
        column.map(item => {
          if (item.value) {
            vals[item.prop] = item.value
          }
        })
      }
      return vals
    },
    handleIframeConfirm() {
      this.dialogVisible = false

      if (window.iframeData) {
        const {
          prop
        } = this.column

        const row = {}
        this.column.children.column.map(item => {
          // if (!item.hide) {
          row[item.prop] = ''
          // }
        })
        console.log('请注意导入每行属性值为：', row)

        this.viewFormData.modelData[prop] = window.iframeData
      }
    },
    convertUrl(scope, URL) {
      if (!URL) {
        return ''
      }

      const urls = URL.split('?')
      if (urls.length < 2) {
        // window.open(urls[0])
        return urls[0]
      }
      const kvs = urls[1].split('&')
      let params = ''
      kvs.map(item => {
        const kvStr = item.split('=$')
        if (kvStr.length === 1) {
          params += item + '&'
        } else {
          const key = kvStr[1].slice(1, -1)

          let val = ''
          if (key.includes('main.')) {
            const mainKey = key.replace('main.', '')
            val = this.viewFormData.modelData[mainKey]
          } else {
            if (scope?.row) {
              console.log(scope.row[key])
              val = scope.row[key]
            }
          }

          if (!val) {
            val = 'null'
          }

          params += kvStr[0] + '=' + val + '&'
        }
      })
      return `${urls[0]}?${params}`.slice(0, -1)
    },
    handleExtEvent(scope = null, item) {
      const {
        prop,
        onClick,
        openURL,
        iframeURL
      } = item
      if (prop === 'import-excel') {
        this.uploadView.show = true
      } else if (prop === 'download-data') {
        this.$downloadFile.get('/excel-export/export-sub-data', {
          params: {
            fileName: this.column.label + '.xls',
            fileUniqueCode: this.column.templatePathFileListExport[0].fileUniqueCode,
            subProp: this.column.prop,
            formId: this.viewFormData.options.formId,
            dataId: this.viewFormData.modelData.id,
            doDownload: true
          }
        }).then(_ => {}).catch(error => {
          this.$message.error(`加载文件失败..${error.msg || error.message}`)
        })
      } else if (prop === 'download-template') {
        this.$downloadFile.get('/excel-export/export-sub-template', {
          params: {
            fileName: this.column.label + '-导出模板.xls',
            fileUniqueCode: this.column.templatePathFileListImport[0].fileUniqueCode,
            doDownload: true
          }
        }).then(_ => {}).catch(error => {
          this.$message.error(`加载文件失败..${error.msg || error.message}`)
        })
      } else if (prop === 'delete') {
        this.rowDel(scope.row, scope.index)
      } else {
        switch (onClick) {
          case 'openURL': {
            const newURL = this.convertUrl(scope, openURL)
            window.open(newURL, '_blank')
            break
          }
          case 'eventName': {
            const obj = { that: this, item, window }
            if (scope?.row) {
              obj.row = scope.row
            }
            saferEval(`(function () {${item.eventName}})()`, obj)
            break
          }
          case 'dialog': {
            window.viewFormData = this.viewFormData
            this.dialogVisible = true
            let newURL = this.convertUrl(scope, iframeURL)
            if (scope) {
              newURL = newURL.indexOf('?') > 0 ? newURL + '&index=' + scope.index : newURL + '?index=' + scope.index
            }
            let urlRet = `${newURL}`
            this.dialogItem = {
              ...item,
              iframeURL: urlRet.indexOf('http') >= 0 ? `${newURL}` : `${vueConfig.publicPath}${newURL}`
            }
            break
          }
        }
      }
    }
  }
}

export default mixinExtMenu
